module.exports = __webpack_public_path__ + "fonts/413d9688-00d4-47c4-bb55-656a0cd396e9.dbdf4df9.eot";